import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IBookModuleConfig } from '../../redux/models/book/module-config';
import { Store, select } from '@ngrx/store';
import { State, __config_book } from '../../redux/reducers';
import { filter, map, distinctUntilChanged } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BookService {
  bookConfigLoaded$: Observable<IBookModuleConfig>;
  baseUrl$: Observable<string>;

  constructor(private readonly store: Store<State>) {}
  getLoadedConfig(): Observable<IBookModuleConfig> {
    if (!this.bookConfigLoaded$) {
      this.initConfig();
    }
    return this.bookConfigLoaded$;
  }

  getServiceUrl(): Observable<string> {
    if (!this.baseUrl$) {
      this.baseUrl$ = this.getLoadedConfig().pipe(
        map(config => config.base_url),
        distinctUntilChanged()
      );
    }
    return this.baseUrl$;
  }

  private initConfig() {
    this.bookConfigLoaded$ = this.store.pipe(
      select(__config_book),
      filter(bookConfig => bookConfig.config && !bookConfig.isLoading),
      map(bookConfig => bookConfig.config)
    );
  }
}
